import { AuditLog } from '@/common/model/analytics'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

const actionBadgeType = (action: string): BadgeType => {
  switch (action) {
    case 'login':
      return BadgeType.EMPHASIS
    case 'login_failed':
      return BadgeType.CRITICAL
    case 'logout':
      return BadgeType.SECONDARY
    case 'create':
      return BadgeType.SUCCESS
    case 'update':
      return BadgeType.CAUTION
    case 'delete':
      return BadgeType.CRITICAL
    case 'export':
      return BadgeType.DEFAULT
    default:
      return BadgeType.SECONDARY
  }
}

interface Props {
  log: AuditLog
  isScrolled: boolean
}

const AuditLogListRow = ({ log, isScrolled }: Props) => {
  return (
    <TableRow>
      <TableRowItem scrollShadow={isScrolled} width={160}>
        <Text size={12} color={TextColor.SECONDARY} nowrap>
          {log.created_at?.slice(0, 19).replace('T', ' ')}
        </Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={12}>{log.operator_name ?? '-'}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Badge badgeType={actionBadgeType(log.action)}>{log.action}</Badge>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={12} color={TextColor.SECONDARY}>
          {log.resource_type ?? '-'}
        </Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={12} color={TextColor.SECONDARY}>
          {log.resource_id ?? '-'}
        </Text>
      </TableRowItem>
      <TableRowItem>
        <Text size={12} color={TextColor.SECONDARY} truncate>
          {log.detail ?? '-'}
        </Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={12} color={TextColor.SECONDARY}>
          {log.ip_address ?? '-'}
        </Text>
      </TableRowItem>
      <TableRowItem width={200}>
        <Text size={12} color={TextColor.SECONDARY} truncate>
          {log.user_agent ?? '-'}
        </Text>
      </TableRowItem>
    </TableRow>
  )
}

export default AuditLogListRow
